<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>合作方设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content">
      <div v-for="(v,index) in titleList" :class="v.name=='绿云'?'activeLv':''" :key="index">
        <div>
          <div>{{v.name}}</div>
          <div class="setCur" @click="setFn(v)">设置></div>
        </div>
        <el-divider></el-divider>
        <div v-if="v.name=='去哪儿'">
          <div class="contents">
            <p>supplierIdentity：</p>
            <p>{{v.supplierIdentity}}</p>
          </div>
          <div class="contents">
            <p>signkey：</p>
            <p>{{v.signkey}}</p>
          </div>
        </div>
        <div v-if="v.name=='美团'">
          <div class="contents">
            <p>partnerId：</p>
            <p>{{v.partnerId}}</p>
          </div>
          <div class="contents">
            <p>clientId：</p>
            <p>{{v.clientId}}</p>
          </div>
          <div class="contents">
            <p>clientSecret：</p>
            <p>{{v.clientSecret}}</p>
          </div>
        </div>
        <div v-if="v.name=='携程'">
          <div class="contents">
            <p>accountid：</p>
            <p>{{v.accountid}}</p>
          </div>
          <div class="contents">
            <p>signkey：</p>
            <p>{{v.signkey}}</p>
          </div>
          <div class="contents">
            <p>aeskey：</p>
            <p>{{v.aeskey}}</p>
          </div>
          <div class="contents">
            <p>aesiv：</p>
            <p>{{v.aesiv}}</p>
          </div>
          <div class="contents">
            <p>url：</p>
            <p>{{v.url}}</p>
          </div>
        </div>
        <div v-if="v.name=='抖音'">
          <div class="contents">
            <p>门店id：</p>
            <p>{{v.poi_id}}</p>
          </div>
          <div class="contents">
            <p>抖音账户</p>
            <p>{{v.account_id}}</p>
          </div>
        </div>
        <div v-if="v.name=='快手'">
          <div class="contents">
            <p>门店id(poi_id)：</p>
            <p>{{v.poi_id}}</p>
          </div>
          <div class="contents">
            <p>主账号快手id：</p>
            <p>{{v.uid}}</p>
          </div>
        </div>
        <div class="lvyun" v-if="v.name=='绿云'">
          <div>
            <span>大会员配置</span>
            <div class="contents">
              <p>hotelGroupCode：</p>
              <p>{{v.hotelGroupCode}}</p>
            </div>
            <div class="contents">
              <p>hotelCode：</p>
              <p>{{v.hotelCode}}</p>
            </div>
            <div class="contents">
              <p>appKey：</p>
              <p>{{v.appKey}}</p>
            </div>
            <div class="contents">
              <p>secret：</p>
              <p>{{v.secret}}</p>
            </div>
            <div class="contents">
              <p>ly_url：</p>
              <p>{{v.ly_url}}</p>
            </div>
          </div>
          <div>
            <span>线上票务</span>
            <div class="contents">
              <p>apiKeyTicket：</p>
              <p>{{v.apiKeyTicket}}</p>
            </div>
            <div class="contents">
              <p>comKeyTicket：</p>
              <p>{{v.comKeyTicket}}</p>
            </div>
            <div class="contents">
              <p>xwturl：</p>
              <p>{{v.xwturl}}</p>
            </div>
            <div class="contents">
              <p>NotifyURL：</p>
              <p>{{v.NotifyURL}}</p>
            </div>
          </div>
          <div>
            <span>客房配置</span>
            <div class="contents">
              <p>hotelGroupCodeRoom：</p>
              <p>{{v.hotelGroupCodeRoom}}</p>
            </div>
            <div class="contents">
              <p>hotelGroupId：</p>
              <p>{{v.hotelGroupId}}</p>
            </div>
            <div class="contents">
              <p>hotelGroupDescript：</p>
              <p>{{v.hotelGroupDescript}}</p>
            </div>
            <div class="contents">
              <p>hotelurl：</p>
              <p>{{v.hotelurl}}</p>
            </div>
            <div class="contents">
              <p>hotelurl2：</p>
              <p>{{v.hotelurl2}}</p>
            </div>

            <!-- <div class="contents">
              <p>passwordRomm：</p>
              <p>{{v.passwordRomm}}</p>
            </div>
            <div class="contents">
              <p>usernameRoom：</p>
              <p>{{v.usernameRoom}}</p>
            </div>
            <div class="contents">
              <p>method：</p>
              <p>{{v.method}}</p>
            </div>
            <div class="contents">
              <p>hotelCodes：</p>
              <p>{{v.hotelCodes}}</p>
            </div>
            <div class="contents">
              <p>appKeyRoom：</p>
              <p>{{v.appKeyRoom}}</p>
            </div>
            <div class="contents">
              <p>appSecretRoom：</p>
              <p>{{v.appSecretRoom}}</p>
            </div>
            <div class="contents">
              <p>scene：</p>
              <p>{{v.scene}}</p>
            </div>
            <div class="contents">
              <p>format：</p>
              <p>{{v.format}}</p>
            </div>
            <div class="contents">
              <p>v：</p>
              <p>{{v.v}}</p>
            </div>
            <div class="contents">
              <p>local：</p>
              <p>{{v.local}}</p>
            </div>
            <div class="contents">
              <p>empno：</p>
              <p>{{v.empno}}</p>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 设置弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      :title="titleType+'设置'"
      :visible.sync="setVisible"
      :before-close="setHandleClose"
      width="50%"
      center
      top="15vh"
    >
      <div class="divider">
        <el-divider></el-divider>
      </div>
      <div class="mtFrom" v-if="nameType=='美团'">
        <el-form ref="rulesform" :model="form" :rules="rules" label-width="180px">
          <el-form-item label="partnerld:" prop="partnerId">
            <el-input v-model.trim="form.partnerId" placeholder="请输入" ></el-input>
          </el-form-item>
          <el-form-item label="clientld:" prop="clientId">
            <el-input v-model.trim="form.clientId" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="clientsecret:" prop="clientSecret">
            <el-input v-model.trim="form.clientSecret" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="btn">
              <!-- <el-button>清空</el-button> -->
              <el-button class="btnL" @click="Meituan('rulesform')">确认保存</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="mtFrom" v-if="nameType=='携程'">
        <el-form ref="form3" :model="form3" :rules="rules" label-width="180px">
          <el-form-item label="accountId:" prop="accountid">
            <el-input v-model.trim="form3.accountid" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="signKey:" prop="signkey">
            <el-input v-model.trim="form3.signkey" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="aesKey:" prop="aeskey">
            <el-input v-model.trim="form3.aeskey" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="aesIv:" prop="aesiv">
            <el-input v-model.trim="form3.aesiv" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="url:" prop="url">
            <el-input v-model.trim="form3.url" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="btn">
              <!-- <el-button>清空</el-button> -->
              <el-button class="btnL" @click="XCBtns('form3')">确认保存</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 设置弹框结束 -->
  </div>
</template>

<script>
import {supplySetQunar,
  supplySetMeituan,
  supplySetXiechen,
  supplySetMeituanSave,
  supplySetMeituanAdd,
  supplySetQunarAdd,
  supplySetQunarSave,
  supplySetXiechenAdd,
  supplySetXiechenSave,
  addKuaiShou,getKuaiShou,updateKuaiShou,
  getDouYin,addDouYin,updateDouYin ,
  LyScenicList , LyScenicAdd , LyScenicSave}  from '@/request/scenic.js'
  import {Message} from 'element-ui'
export default {
  data() {
    return {
      setVisible: false, // 点击设置
      titleType: "", // 弹框标题
      nameType: "", // 弹框显示内容
      titleList: [
        {
          name:'美团',
          partnerId:'',
          clientId:'',
          clientSecret:''
        },
        {
          name:'携程',
          accountid:'',
          signkey:'',
          aesiv:'',
          aeskey:'',
          url:''
        },
      ],
      form6:{
        id:'',
        token:window.sessionStorage.getItem('Token'),
        hotelGroupCode:'',
        hotelCode:'',
        appKey:'',
        secret:'',
        ly_url:'',
        apiKeyTicket:'',
        comKeyTicket:'',
        NotifyURL:'',
        hotelGroupCodeRoom:'',
        hotelGroupId:'',
        hotelGroupDescript:'',
        hotelurl:'',
        hotelurl2:'',
        xwturl:'',
        passwordRomm:'',
        usernameRoom:'',
        method:'',
        hotelCodes:'',
        appKeyRoom:'',
        appSecretRoom:'',
        scene:'',
        format:'',
        v:'',
        local:"",
        empno:''
      },
      form: {
        token:window.sessionStorage.getItem('Token'),
        partnerId:'',
        clientId:'',
        clientSecret:''
      },
      form2:{
        token:window.sessionStorage.getItem('Token'),
        supplierIdentity:'',
        signkey:'',
        scenicid:'',
        id:''
      },
      MeituanFalse:false,
      QuNaFalse:false,
      XCFalse:false,
      form3:{
        token:window.sessionStorage.getItem('Token'),
        accountid:'',
        signkey:'',
        aeskey:'',
        aesiv:'',
        url:'',
        id:''
      },
      form4:{
        token:window.sessionStorage.getItem('Token'),
        poi_id:'',
        id:'',
        account_id:''
      },
      form5:{
        token:window.sessionStorage.getItem('Token'),
        poi_id:'',
        uid:'',
        id:''
      },
      listArr:[],
      rules:{
        partnerld: { required: true, message: '请输入partnerld', trigger: 'blur' },
        clientld: { required: true, message: '请输入clientld', trigger: 'blur' },
        clientsecret: { required: true, message: '请输入clientsecret', trigger: 'blur' },
        supplierIdentity: { required: true, message: '请输入supplierIdentity', trigger: 'blur' },
        signkey: { required: true, message: '请输入signkey', trigger: 'blur' },
        accountid:{ required: true, message: '请输入accountid', trigger: 'blur' },
        aeskey:{ required: true, message: '请输入aeskey', trigger: 'blur' },
        aesiv:{ required: true, message: '请输入aesiv', trigger: 'blur' },
        url:{ required: true, message: '请输入url', trigger: 'blur' },
        poi_id:{required: true, message: '请输入poi_id', trigger: 'blur'},
        uid:{required: true, message: '请输入uid', trigger: 'blur'}
      }
    };
  },
  created(){
    // this.List()
  },
  methods: {
    lvyunBtns(form){
      this.$refs[form].validate((valid) => {
          if (valid) {
            if(this.form6.id){
              LyScenicSave(this.form6).then(res=>{
                if(res.data.status=='ok'){
                  this.setVisible = false;
                  this.List()
                  this.$message.success('修改成功')
                }else{
                  Message.error(res.data.msg)
                }
              })
            }else{
              LyScenicAdd(this.form6).then(res=>{
                if(res.data.status=='ok'){
                  this.setVisible = false;
                  this.List()
                  this.$message.success('添加成功')
                }else{
                  Message.error(res.data.msg)
                }
              })
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    // 携程修改与添加
    XCBtns(form){
       this.titleList.map(item=>{
          if(item.name=='携程'){
            this.form3.id = item.id
          }
       })
     
      this.$refs[form].validate((valid) => {
          if (valid) {
            if(this.XCFalse){
              // 
              for(let i=0;i<this.titleList.length;i++){
                if(this.titleList[i].name=='携程'){
                  if(this.titleList[i].accountid==this.form3.accountid&&this.titleList[i].signkey==this.form3.signkey&&this.titleList[i].aeskey==this.form3.aeskey&&this.titleList[i].aesiv==this.form3.aesiv){
                      Message.error('请输入需要修改的信息')
                      return false
                  }
                }
              }
              supplySetXiechenSave(this.form3).then(res=>{
                if(res.data.status=='ok'){
                  this.setVisible = false;
                  this.List()
                  this.$message.success('修改成功')
                }else{
                    Message.error(res.data.msg)
                }
              })
            }else{
              supplySetXiechenAdd(this.form3).then(res=>{
                if(res.data.status=='ok'){
                  this.setVisible = false;
                  this.List()
                  this.$message.success('添加成功')
                }else{
                    Message.error(res.data.msg)
                }
              })
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    // 美团修改与添加
    Meituan(form){
      console.log(this.form)
      return false
       this.titleList.map(item=>{
          if(item.name=='美团'){
            this.form.id = item.id
          }
       })
     
       this.$refs[form].validate((valid) => {
          if (valid) {
            if(this.MeituanFalse){
              for(let i=0;i<this.titleList.length;i++){
                if(this.titleList[i].name=='美团'){
                  if(this.titleList[i].clientId==this.form.clientId&&this.titleList[i].clientSecret==this.form.clientSecret&&this.titleList[i].partnerId==this.form.partnerId){
                      Message.error('请输入需要修改的信息')
                      return false
                  }
                }
              }
                supplySetMeituanSave(this.form).then(res=>{
                  if(res.data.status=='ok'){
                    this.setVisible = false;
                    this.List()
                    this.$message.success('修改成功')
                  }else{
                    Message.error(res.data.msg)
                  }
                })
              }else{
                supplySetMeituanAdd(this.form).then(res=>{
                  if(res.data.status=='ok'){
                    this.setVisible = false;
                    this.List()
                    this.$message.success('添加成功')
                  }else{
                    Message.error(res.data.msg)
                  }
                })
              }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    // 去哪儿修改与添加
    QuNaBtns(form){
      this.titleList.map(item=>{
          if(item.name=='去哪儿'){
            this.form2.id = item.id
          }
       })
       this.$refs[form].validate((valid) => {
          if (valid) {
            if(this.QuNaFalse){
              for(let i=0;i<this.titleList.length;i++){
                if(this.titleList[i].name=='去哪儿'){
                  if(this.titleList[i].supplierIdentity==this.form2.supplierIdentity&&this.titleList[i].signkey==this.form2.signkey){
                      Message.error('请输入需要修改的信息')
                      return false
                  }
                }
              }
              supplySetQunarSave(this.form2).then(res=>{
                if(res.data.status=='ok'){
                  this.setVisible = false;
                  this.List()
                  this.$message.success('修改成功')
                }else{
                  Message.error(res.data.msg)
                }
              })
            }else{
              supplySetQunarAdd(this.form2).then(res=>{
                if(res.data.status=='ok'){
                  this.setVisible = false;
                  this.List()
                  this.$message.success('添加成功')
                }else{
                  Message.error(res.data.msg)
                }
              })
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },  
    douyinUp(form){
      this.$refs[form].validate((valid) => {
          if (valid) {
            if(this.form4.id){
              for(let i=0;i<this.titleList.length;i++){
                if(this.titleList[i].name=='抖音'){
                  if(this.titleList[i].poi_id==this.form4.poi_id&&this.titleList[i].account_id==this.form4.account_id){
                      Message.error('请输入需要修改的信息')
                      return false
                  }
                }
              }
              updateDouYin(this.form4).then(res=>{
                if(res.data.status=='ok'){
                  this.setVisible = false;
                  this.List()
                  this.$message.success('修改成功')
                }else{
                  Message.error(res.data.msg)
                }
              })
            }else{
              addDouYin(this.form4).then(res=>{
                if(res.data.status=='ok'){
                  this.setVisible = false;
                  this.List()
                  this.$message.success('添加成功')
                }else{
                  Message.error(res.data.msg)
                }
              })
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },  
    kuaishouUp(form){
      this.$refs[form].validate((valid) => {
          if (valid) {
            if(this.form5.id){
              for(let i=0;i<this.titleList.length;i++){
                if(this.titleList[i].name=='快手'){
                  if(this.titleList[i].poi_id==this.form5.poi_id&&this.titleList[i].uid==this.form5.uid){
                      Message.error('请输入需要修改的信息')
                      return false
                  }
                }
              }
              updateKuaiShou(this.form5).then(res=>{
                if(res.data.status=='ok'){
                  this.setVisible = false;
                  this.List()
                  this.$message.success('修改成功')
                }else{
                  Message.error(res.data.msg)
                }
              })
            }else{
              addKuaiShou(this.form5).then(res=>{
                if(res.data.status=='ok'){
                  this.setVisible = false;
                  this.List()
                  this.$message.success('添加成功')
                }else{
                  Message.error(res.data.msg)
                }
              })
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    List(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
      }
      supplySetQunar(data).then(res=>{
        if(res.data.status=='ok'){
          this.titleList[2].supplierIdentity = res.data.result[0].supplierIdentity
          this.titleList[2].signkey = res.data.result[0].signkey
          this.titleList[2].id = res.data.result[0].id
          this.form2.scenicid = res.data.result[0].scenicid
        }
      })
      supplySetMeituan(data).then(res=>{
        if(res.data.status=='ok'){
            this.titleList[0].partnerId = res.data.result[0].partnerId
            this.titleList[0].clientSecret = res.data.result[0].clientSecret
            this.titleList[0].clientId = res.data.result[0].clientId
            this.titleList[0].id = res.data.result[0].id
        }
      })
      supplySetXiechen(data).then(res=>{
        if(res.data.status=='ok'){
          this.titleList[1].accountid=res.data.result[0].accountid
          this.titleList[1].signkey=res.data.result[0].signkey
          this.titleList[1].aeskey=res.data.result[0].aeskey
          this.titleList[1].aesiv=res.data.result[0].aesiv
          this.titleList[1].url=res.data.result[0].url
          this.titleList[1].id=res.data.result[0].id
        }
      })
      getKuaiShou(data).then(res=>{
        if(res.data.status=='ok'){
            this.titleList[4].poi_id = res.data.result.poi_id
            this.titleList[4].uid = res.data.result.uid
            this.titleList[4].id = res.data.result.id
        }
      })
      getDouYin(data).then(res=>{
        if(res.data.status=='ok'){
            this.titleList[3].poi_id = res.data.result.poi_id
            this.titleList[3].id = res.data.result.id
            this.titleList[3].account_id = res.data.result.account_id
        }
      })
      LyScenicList(data).then(res=>{
        if(res.data.status=='ok'){
            // this.titleList[5].poi_id = res.data.result.poi_id
            // this.titleList[5].id = res.data.result.id
            // this.titleList[5].account_id = res.data.result.account_id
            this.titleList[5].hotelGroupCode = res.data.result[0].hotelGroupCode
            this.titleList[5].hotelCode = res.data.result[0].hotelCode
            this.titleList[5].appKey = res.data.result[0].appKey
            this.titleList[5].secret = res.data.result[0].secret
            this.titleList[5].ly_url = res.data.result[0].ly_url
            this.titleList[5].apiKeyTicket = res.data.result[0].apiKeyTicket
            this.titleList[5].comKeyTicket = res.data.result[0].comKeyTicket
            this.titleList[5].NotifyURL = res.data.result[0].NotifyURL
            this.titleList[5].hotelGroupCodeRoom = res.data.result[0].hotelGroupCodeRoom
            this.titleList[5].hotelGroupId = res.data.result[0].hotelGroupId
            this.titleList[5].hotelGroupDescript = res.data.result[0].hotelGroupDescript
            this.titleList[5].hotelurl =  res.data.result[0].hotelurl
            this.titleList[5].hotelurl2 = res.data.result[0].hotelurl2
            this.titleList[5].xwturl = res.data.result[0].xwturl
            this.form6.id = res.data.result[0].id
            this.titleList[5].passwordRomm = res.data.result[0].passwordRomm
            this.titleList[5].usernameRoom = res.data.result[0].usernameRoom
            this.titleList[5].method = res.data.result[0].method
            this.titleList[5].hotelCodes = res.data.result[0].hotelCodes
            this.titleList[5].appKeyRoom = res.data.result[0].appKeyRoom
            this.titleList[5].appSecretRoom = res.data.result[0].appSecretRoom
            this.titleList[5].scene = res.data.result[0].scene
            this.titleList[5].format = res.data.result[0].format
            this.titleList[5].v = res.data.result[0].v
            this.titleList[5].local = res.data.result[0].local
            this.titleList[5].empno = res.data.result[0].empno
        }
      })
      this.listArr = this.titleList
    },
    // 点击设置
    setFn(v) {
      this.nameType = v.name;
      if (v.name == "美团") {
        this.form.partnerId=v.partnerId
        this.form.clientId=v.clientId
        this.form.clientSecret=v.clientSecret
        if(v.partnerId&&v.clientId&&v.clientSecret){
          this.MeituanFalse = true
        }
        this.titleType = "美团";
      }
      if (v.name == "携程") {
        this.titleType = "携程";
        this.form3.accountid=v.accountid
        this.form3.signkey=v.signkey
        this.form3.aeskey=v.aeskey
        this.form3.aesiv=v.aesiv
        this.form3.url=v.url
        if(v.accountid&&v.signkey&&v.aeskey&&v.aesiv&&v.url){
          this.XCFalse = true
        }
      }
    
      if (v.name == "去哪儿") {
        this.titleType = "去哪儿";
        this.form2.supplierIdentity = v.supplierIdentity
        this.form2.signkey  = v.signkey
        if(v.signkey&&v.supplierIdentity){
          this.QuNaFalse = true
        }
      }
      if(v.name=='抖音'){
        this.titleType = "抖音";
        this.form4.poi_id = v.poi_id
        this.form4.account_id = v.account_id
        this.form4.id  = v.id
      }
      if(v.name=='快手'){
        this.titleType = "快手";
        this.form5.poi_id = v.poi_id
        this.form5.id  = v.id
        this.form5.uid  = v.uid
        console.log(this.form4)
      }
      if(v.name=='绿云'){
        this.titleType = "绿云";
        this.form6 = {
          id:this.form6.id,
          token:window.sessionStorage.getItem('Token'),
          hotelGroupCode:v.hotelGroupCode,
          hotelCode:v.hotelCode,
          appKey:v.appKey,
          secret:v.secret,
          ly_url:v.ly_url,
          apiKeyTicket:v.apiKeyTicket,
          comKeyTicket:v.comKeyTicket,
          NotifyURL:v.NotifyURL,
          hotelGroupCodeRoom:v.hotelGroupCodeRoom,
          hotelGroupId:v.hotelGroupId,
          hotelGroupDescript:v.hotelGroupDescript,
          hotelurl:v.hotelurl,
          hotelurl2:v.hotelurl2,
          xwturl:v.xwturl
        }
      }
      this.setVisible = true;
    },
    // 点击设置X
    setHandleClose() {
      this.setVisible = false;
    }
  }
};
</script>

<style lang='less' scoped>
.divider {
  // 分割线
  /deep/.el-divider--horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 10px 0 20px 0;
  }
}
/deep/.el-descriptions-item__content {
  word-break: break-word;
  overflow-wrap: break-word;
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}
/deep/.el-descriptions-item__label:not(.is-bordered-label) {
  margin-right: 10px;
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
}
.mtFrom {
  .el-form-item {
    position: relative;
  }
  /deep/.el-form-item__label {
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: right;
    color: #666666;
  }
  .xingA {
    position: absolute;
    top: 0px;
    left: -84px;
    color: #e74c3c;
  }
  .xingB {
    position: absolute;
    top: 0px;
    left: -72px;
    color: #e74c3c;
  }
  .xingC {
    position: absolute;
    top: 0px;
    left: -98px;
    color: #e74c3c;
  }
  .xingX {
    position: absolute;
    top: 0px;
    left: -143px;
    color: #e74c3c;
  }
  .xingZ {
    position: absolute;
    top: 0px;
    left: -118px;
    color: #e74c3c;
  }
  .xing1 {
    position: absolute;
    top: 0px;
    left: -89px;
    color: #e74c3c;
  }
  .xing2 {
    position: absolute;
    top: 0px;
    left: -74px;
    color: #e74c3c;
  }
  .xing3 {
    position: absolute;
    top: 0px;
    left: -68px;
    color: #e74c3c;
  }
  .xing4 {
    position: absolute;
    top: 0px;
    left: -57px;
    color: #e74c3c;
  }
  .xing5 {
    position: absolute;
    top: 0px;
    left: -40px;
    color: #e74c3c;
  }
  .el-input {
    // width: 350px;
  }
}
/deep/.el-descriptions-item__cell .el-descriptions-item__label {
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  margin-bottom: 0px;
}
/deep/.el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 5px;
}

.content {
  width: 100%;
  height: 100%;
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  > div {
    min-width: 23%;
    width: auto;
    background: #ffffff;
    border-radius: 4px;
    margin-right: 20px;
    margin-bottom: 20px;
    padding: 20px;
    > div:nth-child(1) {
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      > div:nth-child(1) {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        color: #000000;
      }
      > div:nth-child(2) {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        color: #666666;
      }
    }
  }
}
// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0 10px 0;
}
.btn {
  // margin: 20px 100px 10px 0;
  margin-top: 20px;
  margin-left: -100px;
  display: flex;
  justify-content: center;
  .el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
/deep/.el-dialog__header {
  // height: 60px;
  // line-height: 60px;
  // padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}
/deep/ .tbody{
  display: flex;
}
.contents{
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1.3rem;
  font-size: 1.4rem;
}
.contents p:nth-child(2){
  color: #000;
  table-layout: fixed;
  word-break: break-all;
  overflow: hidden;
}
.contents p{
  padding: 0;
  font-size: 1.4rem;
}
.flex_lvyun{
  display: flex;
  align-items: center;
  ::v-deep .el-form-item{
    width: 50%;
  }
}

.lvyun{
  display: flex;
  >div{
    margin-left: 2rem;
    width: 30rem;
    >span{
      color: #000;
      font-weight: 600;
      font-weight: 2rem;
    }
  }
}
.form_title{
  font-weight: 600;
  font-size: 1.6rem;
  color: #000;
  margin-bottom: 1rem;
}
</style>